import { useState, useMemo, useEffect } from 'react';
import { IconButton } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useAtom, useAtomValue } from 'jotai';
import * as kpiState from '../../state';
import { ColumnsSelectionDialog } from './ColumnsSelectionDialog';

export const ColumnsButton = () => {
  const [isColumnDialogOpen, setIsColumnDialogOpen] = useState(false);
  const [visibleColumnKeys, setVisibleColumnKeys] = useAtom(kpiState.visibleColumnKeys);
  const selectedWorklogsTemplate = useAtomValue(kpiState.selectedWorklogsTemplate);

  const templateFields = useMemo(() => {
    return selectedWorklogsTemplate?.fields.filter((field) => field.displayInLogAggregation) ?? [];
  }, [selectedWorklogsTemplate]);

  // Initialize visible columns when template fields change (all visible by default)
  useEffect(() => {
    if (templateFields.length > 0 && visibleColumnKeys === undefined) {
      const allKeys = templateFields.map((field) => field.key).filter(Boolean) as string[];
      setVisibleColumnKeys(allKeys);
    }
  }, [templateFields, visibleColumnKeys, setVisibleColumnKeys]);

  return (
    <>
      <IconButton
        color="primary"
        size="small"
        onClick={() => setIsColumnDialogOpen(true)}
        id="kpi-tracker-columns-selction-button"
      >
        <SettingsIcon fontSize="small" />
      </IconButton>

      <ColumnsSelectionDialog
        open={isColumnDialogOpen}
        onClose={() => setIsColumnDialogOpen(false)}
      />
    </>
  );
};
